import image from "../../asserts/images/404.gif";
export const NotFoundPage = () => {
  return (
    <div
      style={{
        height: "calc(100vh - 150px)",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div className="container text-center">
        <img
          src={image}
          className="w-100 img img-responsive "
          alt="error 404"
        />
        <h2>Page not found!</h2>
      </div>
    </div>
  );
};
